<template>
<div v-if="pageData" class="c-mv5" :class="{'c-mv5--modal': pageData.modal}">
  <div class="c-mv5__main" @click="openModal">
    <img :src="pageData.photo.src" alt="" />
    <button v-if="pageData.modal" class="c-btnModal c-btnModal--rd">
      <span></span>
    </button>
  </div>
</div>
</template>

<script>
import {gsap, Power3, Expo} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
    }
  },
  props: ['name'],
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // 画像
    const img = new Image();
    img.onload = () => {
      this.loaded({width: img.width, height: img.height});
    }
    img.src = this.pageData.photo.src;
  },
  methods: {
    once() {
      // 画像表示
      const photo = this.$el.querySelector('.c-mv5__main img');
      let viewPhoto = gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: 'top 90%',
          end: 'top 10%',
          once: true,
          // scrub: 0.7,
          // markers: true,
        }
      });

      viewPhoto.addLabel('start')
      .fromTo(photo, {
        scale: 1.3,
      }, {
        duration: 1.0,
        scale: 1,
        ease: Power3.easeOut,
      }, 'start')
      .fromTo(photo, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Power3.easeOut,
      }, 'start+=0.1');
    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    loaded(e) {
      this.$nextTick(this.once);
    },
  }
}
</script>